//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import PhoneHeader from '../common/phoneHeader'
  import PhoneMask from '../common/phoneMask'
  import pcHeader from '../common/pcHeader'
export default {
  name: 'community',
  components: {
    PhoneHeader,
    PhoneMask,
    pcHeader
  },
  data () {
    return {
      isPhone: false,
      screenHeight: null,
      isOpen:false
    }
  },
  mounted () {
    if (this.handleIsPhone()) {
      this.isPhone = true
      this.screenHeight = window.screen.height
    } else {
      this.isPhone = false
    }
  },
  methods: {
    handleIsPhone() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    handleToWeb () {
      location.href = 'http://pc.dnaer.net/#/'
    },
    handleToCommunity () {
      this.$router.push({name: 'community'})
    },
    handleToUser () {
      this.$router.push({name: 'userProtocol'})
    },
    handleToPricacy () {
      this.$router.push({name: 'privacy'})
    },
    handleToHome () {
      this.$router.push({name: 'home'})
    },
    handleGetOpen (data) {
      this.isOpen = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/html/community.vue